export const CHANGE_CONFIG = 'CHANGE_CONFIG';
import DistEvents from '@gameday/core/events/DistEvents';
const { CONFIG_CHANGE } = DistEvents;
import MessageService from 'message-service/message-service';


const changeConfig = (data) => (dispatch, getState) => {
    
    const state = getState();
    const {
        config
    } = state;

    
    const configChange = {
        ...config,
        ...data
    };

    MessageService.publish(CONFIG_CHANGE, configChange);

    dispatch({
        type: CHANGE_CONFIG,
        viewtype: configChange
    });
};

export default changeConfig;